/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsEodSetting
 */
export interface EodMelcoEodModelsEodSetting {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodSetting
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodSetting
     */
    partner?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodSetting
     */
    auth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodSetting
     */
    url?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EodMelcoEodModelsEodSetting
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EodMelcoEodModelsEodSetting
     */
    last_activity?: Date | null;
}

export function EodMelcoEodModelsEodSettingFromJSON(json: any): EodMelcoEodModelsEodSetting {
    return EodMelcoEodModelsEodSettingFromJSONTyped(json, false);
}

export function EodMelcoEodModelsEodSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsEodSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'partner': !exists(json, 'partner') ? undefined : json['partner'],
        'auth': !exists(json, 'auth') ? undefined : json['auth'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'last_activity': !exists(json, 'last_activity') ? undefined : (json['last_activity'] === null ? null : new Date(json['last_activity'])),
    };
}

export function EodMelcoEodModelsEodSettingToJSON(value?: EodMelcoEodModelsEodSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'partner': value.partner,
        'auth': value.auth,
        'url': value.url,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'last_activity': value.last_activity === undefined ? undefined : (value.last_activity === null ? null : value.last_activity.toISOString()),
    };
}


